<template>
	<Header />
	
	<WhatsAppFloat
		phone="573108017473"
		text="¡Hola! 👋 Estoy interesado en SELAH y quiero que me guíen con la mejor opción para mí."
		position="right"
		:bottom="100"
		:side="20"
	/>

	<router-view :key="$route.params.id" />

	<Footer />
</template>

<script>
	import Header from "@/components/Header.vue";
	import Footer from "@/components/Footer.vue";
	import WhatsAppFloat from "@/components/WhatsApp/WhatsAppFloat.vue";

	export default {
		name: "App",
		components: {
			Header,
			Footer,
			WhatsAppFloat,
		},
	};
</script>
